var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExplanation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 32,
    viewBox: "0 0 48 48",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.2 7.8h7.1c1.1 0 2.1.4 2.8 1.2l4.3 4.3c.8.8 1.2 1.8 1.2 2.8v23.6c0 1.1-.9 2-2 2h-21.5c-1.1 0-2-.9-2-2v-15.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.7 25.1v2.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.7 35.6v8.5c0 1.1.9 2 2 2h21.5c1.1 0 2-.9 2-2v-2.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.7 30.7v1.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m37.1 11.7v1.7c0 1.1.9 2 2 2h1.7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.2 28.7h8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 28.7h3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.4 32.6h3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 32.6h8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.9 36.5h6.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 36.5h5.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.4 21.1h3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.1 21.1h2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.9 25h6.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 25h5.1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m25.7 20.8-5.2-1.1c-1.7.9-3.7 1.4-5.8 1.4-6.3 0-11.4-4.3-11.4-9.6s5.1-9.6 11.4-9.6 11.3 4.3 11.3 9.6c0 1.6-.4 3.1-1.2 4.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.5 9.4c0-2 1.9-3.6 3.9-3.1 1.2.3 2.1 1.2 2.4 2.4.4 1.6-.4 3-1.7 3.6-.8.4-1.4 1.2-1.4 2.2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.7 16.5v.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplanation);
export default __webpack_public_path__ + "static/media/explanation.f61004fcc47d31f535748a39a3a278d2.svg";
export { ForwardRef as ReactComponent };